const validateSubmission = function ({ commit, state }) {
  const featureToggles = {
    multipleCategoriesSubmission: this.$unleash.isEnabled(
      "multipleCategoriesSubmission"
    ),
    submissionAllowPrimaryVideoUpload: this.$unleash.isEnabled(
      "submissionAllowPrimaryVideoUpload"
    ),
    disableSubmissions: this.$unleash.isEnabled("disableSubmissions"),
  };

  commit("VALIDATE_SUBMISSION", featureToggles);

  return Promise.resolve(state.submissionErrors);
};

export default validateSubmission;
